import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBag } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { useToast } from '../hooks/useToast';
import {
  getProductAttributeLabel,
  getProductBadgeLabel,
  getProductImageObjectPosition,
} from '../data/products';

export function ProductCard({ product }) {
  const { addToCart } = useCart();
  const { toast } = useToast();
  const shortDescription =
    (typeof product.shortDescription === 'string' && product.shortDescription.trim()) ||
    (typeof product.longDescription === 'string' && product.longDescription.trim()) ||
    'Rövid leírás hamarosan.';

  const handleAdd = () => {
    addToCart(product, 1);
    toast({
      title: 'Kosárba téve',
      description: `1 db ${product.name} hozzáadva a kosárhoz.`,
    });
  };

  const isFoodCategory = product.category === 'foods' || product.category === 'drinks';
  const badgeLabel = getProductBadgeLabel(product);
  const attributeLabel = getProductAttributeLabel(product);

  const badgeClass =
    isFoodCategory
      ? 'badge-kombucha'
      : product.category === 'household'
        ? 'badge-shots'
        : product.category === 'bodycare'
          ? 'badge-tea'
          : 'badge-category';

  return (
    <div className="card-zinga flex flex-col group">
      <Link to={`/product/${product.id}`}>
        <div className="relative aspect-[4/3] rounded-2xl overflow-hidden border-2 border-transparent bg-secondary/50 transition-colors duration-300 group-hover:border-[#0F3D2C] group-hover:bg-[#0F3D2C]">
          {product.isHungarian ? (
            <span
              className="absolute right-2 top-2 z-10 inline-flex h-5 w-7 flex-col overflow-hidden rounded-sm border border-white/90 bg-white shadow-sm"
              aria-label="Hazai termék"
              title="Hazai termék"
            >
              <span className="h-1/3 w-full bg-[#ce2939]" />
              <span className="h-1/3 w-full bg-white" />
              <span className="h-1/3 w-full bg-[#477050]" />
            </span>
          ) : null}
          <div className="h-full w-full overflow-hidden rounded-[14px] transition-transform duration-300 group-hover:scale-95">
            <img
              src={product.image}
              alt={product.name}
              className="w-full h-full object-cover"
              style={{ objectPosition: getProductImageObjectPosition(product) }}
            />
          </div>
        </div>
      </Link>

      <div className="mt-4 flex flex-wrap gap-2">
        <span className={badgeClass}>{badgeLabel}</span>
        {attributeLabel && (
          <span className="badge-category bg-tea text-foreground">{attributeLabel}</span>
        )}
      </div>

      <Link to={`/product/${product.id}`} className="mt-3">
        <h3 className="font-display text-lg font-semibold hover:text-foreground/80 transition-colors">
          {product.name}
        </h3>
      </Link>
      <p className="text-sm text-muted-foreground mt-2 flex-1">{shortDescription}</p>

      <div className="mt-4 flex items-center justify-between">
        <span className="font-display font-semibold">
          {product.price.toLocaleString('hu-HU')} Ft
        </span>
        <button
          onClick={handleAdd}
          className="btn-secondary text-sm px-4 py-2 !bg-[#EAD2C0] !border-[#E0C5AE] hover:!bg-[#D8B89F]"
        >
          <ShoppingBag className="w-4 h-4" />
          Kosárba
        </button>
      </div>
    </div>
  );
}
